import React from 'react';
import { PawPrint } from 'lucide-react';

interface AlreadyRegisteredNoPetsProps {
  onRegisterPet: () => void;
}

/**
 * Shown when a user who previously declared "no pets" logs back in.
 * Replaces the "Do you have a pet?" modal with a dedicated page offering
 * to register a pet or continue to the dashboard.
 */
const AlreadyRegisteredNoPets: React.FC<AlreadyRegisteredNoPetsProps> = ({
  onRegisterPet,
}) => {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div className="w-full h-full bg-gray-50 flex items-center justify-center overflow-y-auto p-4">
        <div className="flex flex-col items-center space-y-6 px-4 max-w-md w-full">
          <div className="flex items-center">
            <img
              src="/landing/getpawtected.svg"
              alt="GetPawtected Logo"
              className="h-12 sm:h-16 w-auto drop-shadow-sm"
            />
          </div>

          <div className="flex items-center justify-center w-14 h-14 rounded-full bg-blue-100">
            <PawPrint className="w-7 h-7 text-blue-600" aria-hidden />
          </div>

          <div className="text-center space-y-2">
            <h1
              className="text-xl sm:text-2xl text-gray-900 font-semibold"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              You have already registered no pets
            </h1>
            <p
              className="text-base text-gray-600"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              You previously declared that you do not have any pets to register. If you have acquired a pet since then, you can register them below.
            </p>
          </div>

          <div className="w-full max-w-sm space-y-3">
            <button
              type="button"
              onClick={onRegisterPet}
              className="w-full min-h-[48px] px-6 py-3 rounded-full font-semibold bg-[color:var(--pmc-primary)] text-white hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 border-2 border-purple-600 transition-opacity"
              style={{ fontFamily: 'Poppins, sans-serif' }}
              aria-label="Register a pet"
            >
              Register a pet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlreadyRegisteredNoPets;
